import { apiDelete, apiGet, apiPost, API_URI } from './index';

const influencerDiscovery = {
        getAll: async (projectId: number) => {
        const data = await apiGet(`${API_URI}/api/influencerdiscovery/getall?projectId=${projectId}`);
        return data;
    },
    addToInfluencerDiscovery: async (authorId: string, projectId: number, authorName: string, streamId: number) => {
        const data = await apiPost(`${API_URI}/api/influencerdiscovery/create?projectId=${projectId}&authorId=${authorId}&&authorName=${authorName}&streamId=${streamId}`);
        return data;
    },
    remove: async (id: number) => {
        await apiDelete(`${API_URI}/api/influencerdiscovery/delete?id=${id}`)
    }
}

export default influencerDiscovery;